import { createNavigation } from 'next-intl/navigation'
import { defineRouting } from 'next-intl/routing'

import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from './locales'

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: SUPPORTED_LOCALES,

  // Used when no locale matches
  defaultLocale: DEFAULT_LOCALE,

  // Disable locale prefix in URLs
  localePrefix: 'never',
})

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
createNavigation(routing)
